export const formatDateFromString = (value: string) => {
  const parsedDate = new Date(value);
  const parsedMonth = parsedDate.getMonth() + 1;
  const date =
    parsedDate.getDate() < 10
      ? '0' + parsedDate.getDate()
      : parsedDate.getDate();
  const month = parsedMonth < 10 ? '0' + parsedMonth : parsedMonth;
  const year = parsedDate.getFullYear();
  return `${date}-${month}-${year}`;
};
